import { buildBillingContext } from '@/apiCalls/billingContext';
import { postUrl } from '@/apiCalls/fetch';
import { EVehicleAssetType } from '@/context/borrower';
import { getGlassAssetType } from '@/utils/glassGuideHelpers';

export async function getBuildYear(
    partner: string,
    assetType?: EVehicleAssetType
): Promise<string[]> {
    const url = `/api/asset/select/${partner}/${getGlassAssetType(assetType)}`;
    return postUrl<string[]>(url, { billingContext: buildBillingContext() });
}
